

export interface ProductPermissions {
    product: string,
    permissions: string[];
}

export interface CompanyInfo {
    name: string,
    code: string,
    products: string[];
}

export interface Product {
    company: string,
    products: string[];
}
export interface Role {
    name: string,
    company: CompanyShort,
    permissions: string[],
    products: string[];
}

export interface CompanyShort {
    name: string,
    code: string;
}


export class GroupedPermissions {
    label: string;
    items: PermissionNameAndValue[];

    constructor(label: string, items: PermissionNameAndValue[]) {
        this.label = label;
        this.items = items;
    }
}

export class PermissionNameAndValue {
    label: string;
    value: string;

    constructor(label: string, value: string) {
        this.label = label;
        this.value = value;
    }
}


export class Company implements CompanyInfo {
    name: string;
    code: string;
    products: string[] = [];
    roles: Role[] = [];
    roleMap: Record<string, Role> = {};

    constructor(code: string, name: string, products: string[], roles: Role[]) {
        this.name = name;
        this.code = code;
        this.products = products;
        this.roles = roles;
        for (const role of roles) {
            this.roleMap[role.name] = role;
        }
    }

    addRole(role: Role) {
        this.roleMap[role.name] = role;
        this.roles = Object.values(this.roleMap);
    }

    removeRole(role: Role) {
        delete this.roleMap[role.name];
        const index = this.roles.findIndex(existing => existing.name === role.name);
        this.roles.splice(index, 1);
    }

    getRole(name: string) {
        return this.roleMap[name];
    }

    updateRole(update: Role) {
        const existingRole = this.getRole(update.name);
        if (existingRole) {
            existingRole.permissions = update.permissions;
            existingRole.products = update.products;
        }
    }

    getRoleProducts(name: string) {
        return this.roleMap[name].products;
    }
}

